<div class="confirm-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    @if (data.hasClose) {
      <button
        mat-icon-button
        [mat-dialog-close]="false"
        class="close-button"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <p class="dialog-message" [innerHtml]="data.message"></p>
    @if (data.dialogData?.chunkData) {
      <div class="chunk-data-section">
        <ul class="list-group">
          <li class="list-group-item">
            Name -
            <strong>{{
              data.dialogData.chunkData.name
                ? data.dialogData.chunkData.name
                : "No name"
            }}</strong>
          </li>
          <li class="list-group-item">
            Chunk id - <strong>{{ data.dialogData.chunkData.stepId }}</strong>
          </li>
        </ul>
      </div>
    }
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    @if (data.confirmCaption) {
      <button class="confirm-button" [mat-dialog-close]="data">
        {{ data.confirmCaption }}
      </button>
    }
    @if (data.cancelCaption) {
      <button class="cancel-button" [mat-dialog-close]="false">
        {{ data.cancelCaption }}
      </button>
    }
  </div>
</div>
